/* eslint-disable */
module.exports = {
    'Home.title1': '關於我們',
	'Home.title2': '產品介紹',
	'Home.title3': '最近動態',
	'Home.title4': '合作方式',
	'Home.title5': '學生作品集',
	'Home.title6': '聯系我們',
	'Home.title7': '業內領袖',
	'Home.text1': '壹套世界領先的少兒編程好課',
  'Home.AI': '青少年人工智慧教育專家',
  'Home.AI-1': '人工智慧是時代的必修課',
  'Home.AI-2': '為什麼要從小學習人工智慧？',
  'Home.AI-3': '為什麼要選擇暢學？',
  'Home.AI-4': '青少年生成式人工智慧培養方案',
  'Home.AI-5': '項目展示',
	'Home.text2': '打造一套世界第一線的青少年生成式人工智慧好課',
	'Home.entry1': '學校入口',
	'Home.entry2': 'VIP 入口',
	'Home.entry3': '網絡課程',
	'Home.entry4': '師資培訓',
	'Home.entry5': '幼兒園課程',
	'Home.text3': '“暢學編程”',
	'Home.more': '更多詳情',
	'Home.text4': '是上海暢學教育科技有限公司凝聚計算機、基礎教育、國際標準領域專家打造的壹套具有世界壹流水平的少兒編程課程。新加坡、香港、上海、江蘇等教育高地數百家知名學校及幼兒園校本課程采購並開設暢學編程課。',
	'Home.text5': '作為微軟全球合作夥伴，全球計算機科學教師協會會員，同時也是江蘇省青少年智能教育專業委員會的秘書長單位，暢學教育傾力優化老師和學生共享的計算機科學教育平臺，培養更優秀的少兒編程教師，組織有影響力的全國性少兒編程競賽，不斷完善信息化教育生態圈。',
    'Home.leaders': '業內領袖',
	'Home.goCommunity': '進入社區',
	"Home.14": "導論課",
	"Home.15": "一級課程",
	"Home.16": "計算思維入門及軟件",
	"Home.17": "基礎",
	"Home.18": "計算思維提升及物聯網",
	"Home.19": "提升",
	"Home.20": "精煉",
	"Home.21": "計算思維增強及人工智能",
	"Home.22": "計算思維完善與綜合訓練",
	"Home.23": "Python與樹莓派",
	"Home.24": "JavaScript與網絡編程",
	"Home.25": "二級課程",
	"Home.26": "三級課程",
	"Home.27": "四級課程",
	"Home.28": "五級課程",
	"Home.29": "六級課程",
	"Home.school": "開課學校",
	"Home.schoolText": "更多學校正在加入中",
	"introduction.training": "暢學編程擁有完善的師資培訓平臺，集在線師資培訓、在線試聽診斷、線下試 講認證壹體，建立全面的師資培訓認證體系。",
	"introduction.hardware": "暢學編程集合軟件和硬件的教育特點，通過編程控制硬件設備，完成各類創意 智能家居、智能車改裝等，使用靈活的方案解決更復雜的問題。",
	"introduction.lab1-1": "暢學STEAM人工智能編程工作坊（以下簡稱：暢學AI編程工坊）是面向中小學的創新實驗室，具有完整的國產知識產權，將科技創新與中國文化相結合，讓孩子從小具備用計算機創造工具解決問題的思維和能力。現在上海、江蘇等地數百所學校採用，數十萬孩子學習，其知識體系和核心素養達成度效果達到國際一流水平。",
	"introduction.lab1-2": "區別於傳統的基於單項技能的創新實驗室（如：機器人實驗室、軟件編程實驗室或3D創客實驗室），它以STEAM教育理念為指導，配套多元化的信息設備，培養學生綜合運用各種信息技術實現自我創造與夢想的能力！",
	"introduction.lab1-3": "同時，從娃娃抓起，培養國產信息技術生態實踐者，是國家安全發展戰略，也是暢學人的使命，實驗平台及所有課程架構在以中晟宏芯CP1國產服務器為基礎的私有云平台上，平台完美對接各類機器人教具、智能硬件教具、3D創客教具、無人機教具，並積極參與國家標準委員會中小學信息技術教育技術平台標準的製定，推動國產信息技術生態圈的發展。",
	"introduction.lab1-4": "學習過程中，學生首先通過暢學編程課程平台系統的課程，掌握以計算思維為主線的遊戲化軟件編程、智能硬件及物聯網編程、人工智能及機器人編程、三維設計及打印編程，再通過暢學AI編程工坊的多元化設備綜合運用這些知識能力，從無到有實現自己的夢想，打造自己創意產品！很好的滿足了國家在基礎教育中對信息素養教育的要求，全面培養學生計算思維及編程能力，提升學生信息素養，讓學生適應人工智能時代發展需求。",
	"introduction.lab1-5": "當然，暢學STEAM人工智能編程工作坊也同時支持學生學習實踐傳統信息技術課程。",
	"introduction.lab2-1": "暢學STEAM人工智能編程工作坊受國家住建部部長、上海市市領導等讚賞。",
	"introduction.lab2-2": "2019年2月21日上午九時，國家住房和城鄉建設部黨組書記、部長王蒙徽，黨組成員、副部長倪虹等領導，在中共上海市委常委、市政法委書記、副市長陳寅、市府副秘書長黃融、中共長寧區委書記王為人、區長顧洪輝、教育局王小柳書記、姚期局長等領導的陪同下，來到上海市建青實驗學校視察調研用科技改變提升垃圾分類工作。",
	"introduction.lab2-3": "學生們利用在暢學編程課上學習的知識，在暢學STEAM人工智能編程工坊裡動手實踐，用物聯網知識選出傳感器、用3D打印知識做出垃圾筒外殼、用編程邏輯讓垃圾筒智慧起來，真正實現自己的智慧垃圾分類，受到領導的一致讚賞好評，值得大力推廣。",
	"introduction.systemTit": "課程體系",
	"introduction.trainTit": "師資培訓",
	"introduction.hardwareTit": "教學硬件",
	"introduction.laboratoryTit": "教學硬件",
	"introduction.laboratoryTit1": "STEAM人工智能編程工作坊",
	"system1.text1": "計算思維40%知識點的初步認識",
	"system1.text2": "學會創建計算機程序",
	"system1.text3": "用編程語言創建動畫故事，並分享至朋友圈",
	"system1.text4": "用編程語言開發交互式遊戲，並分享至朋友圈",
	"system1.text5": "鍛煉邏輯思維能力，提升信息素養建立初步工程意識",
	"system2.text1": "計算思維50%知識點的基本理解",
	"system2.text2": "開發更加復雜的交互遊戲",
	"system2.text3": "學習硬件組成原理",
	"system2.text4": "初識人工智能的基本原理",
	"system2.text5": "通過編程控制物理世界，完成各類創意智能家居",
	"system2.text6": "具備參加全國青少年科技創新大賽的基本能力",
	"system3.text1": "計算思維80%知識點的理解",
	"system3.text2": "理解網絡並具備基本的網絡安全意識",
	"system3.text3": "開發簡單的應用軟件",
	"system3.text4": "通過編程控制運動設備，完成創意智能車的改裝",
	"system3.text5": "使用更靈活的方案來解決更復雜的問題",
	"system4.text1": "計算思維100%知識點的理解",
	"system4.text2": "具有基本的工程意識",
	"system4.text3": "具備簡單的數據查詢分析能力",
	"system4.text4": "開發具有數據處理能力的應用軟件",
	"system4.text5": "認識深度學習的訓練體系",
	"system4.text6": "具備基本的人工智能+思維",
	"system5.text1": "綜合運用計算思維解決實際問題",
	"system5.text2": "制作、開發手機APP",
	"system5.text3": "能用python編寫程序",
	"system5.text4": "具備獲得國家相關獎項的能力",
	"system6.text1": "能運用計算思維創造新工具",
	"system6.text2": "能用python編寫WEB應用",
	"system6.text3": "能用python操作開源硬件",
	"system6.text4": "能用python調用人工智能",
	"system6.text5": "具備獲得國家相關獎項能力",
	"system.text1": "培養目標",
	"scratch.All": "全部",
	"scratch.Animations": "動畫",
	"scratch.Art": "藝術",
	"scratch.Games": "遊戲",
	"scratch.Music": "音樂",
	"scratch.Stories": "故事",
	"scratch.Tutorials": "教程",
	"scratch.trending": "趨勢",
	"scratch.popular": "流行",
	"scratch.recent": "最新",
	"Product.systemDetection": "系統檢測",
	"DownChromeTip": "下載 ",
	"ChromeBrower": "Chrome 瀏覽器",
}



// WEBPACK FOOTER //
// ./src/i18n/zh_TW.js